<template>
  <div class="modal fade" :class="{ 'show d-block': visible }" ref="mdlInicializarConversacion" data-bs-backdrop="static"
    data-bs-keyboard="false" tabindex="-1" role="dialog"
    :style="visible ? 'display: block; background: rgba(0, 0, 0, 0.55); z-index: 1060;' : ''" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content shadow border-0">
        <!-- Modal Header -->
        <div class="modal-header bg-success text-white py-3">
          <div class="d-flex align-items-center">
            <i class="mdi mdi-chat-plus-outline font-size-22 me-2"></i>
            <div>
              <h5 class="modal-title text-white mb-0 font-size-16">
                Iniciar nueva conversación
              </h5>
              <small class="text-white-50">
                Registra un número de teléfono e inicia el chat en WhatsApp
              </small>
            </div>
          </div>
          <button type="button" class="btn-close btn-close-white" @click="cerrar" aria-label="Cerrar"
            :disabled="enviando"></button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body p-4">
          <!-- Step 1: Número de teléfono y destino -->
          <div class="row g-3 mb-4">
            <div class="col-md-3">
              <label class="form-label font-size-13 fw-semibold text-secondary">
                Prefijo <span class="text-danger">*</span>
              </label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0 text-muted">+</span>
                <input type="text" class="form-control border-start-0" v-model="prefijo" placeholder="52"
                  maxlength="5" :disabled="enviando" />
              </div>
            </div>

            <div class="col-md-9">
              <label class="form-label font-size-13 fw-semibold text-secondary">
                Número telefónico <span class="text-danger">*</span>
              </label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0">
                  <i class="mdi mdi-phone-outline text-muted"></i>
                </span>
                <input type="tel" class="form-control border-start-0" v-model="numeroTelefono"
                  placeholder="Ej. 5512345678" maxlength="15" ref="inputNumero" :disabled="enviando"
                  @keyup.enter="enfocarBusqueda" />
              </div>
              <small class="text-muted font-size-11">
                Ingresa los 10 dígitos del número celular o el número internacional completo.
              </small>
            </div>
          </div>

          <!-- Step 2: Selección de destino (Cliente Varios vs Cliente Específico) -->
          <div class="mb-3">
            <label class="form-label font-size-13 fw-semibold text-secondary d-block mb-2">
              Asignación del contacto:
            </label>
            <div class="d-flex gap-3">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="radioVarios" value="varios" v-model="tipoAsignacion"
                  :disabled="enviando" @change="alCambiarTipoAsignacion" />
                <label class="form-check-label font-size-13 cursor-pointer" for="radioVarios">
                  <span class="badge bg-secondary-subtle text-secondary me-1">Público / Varios</span>
                  Asignar a <strong>Cliente Varios</strong> (sin registrar cliente)
                </label>
              </div>

              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="radioEspecifico" value="cliente"
                  v-model="tipoAsignacion" :disabled="enviando" @change="alCambiarTipoAsignacion" />
                <label class="form-check-label font-size-13 cursor-pointer" for="radioEspecifico">
                  <i class="mdi mdi-account-search-outline text-primary me-1"></i>
                  Asignar a un <strong>Cliente del sistema</strong>
                </label>
              </div>
            </div>
          </div>

          <!-- Si seleccionó un cliente específico: buscador -->
          <div v-if="tipoAsignacion === 'cliente'" class="card border bg-light-subtle mb-3 p-3">
            <!-- Cliente seleccionado actualmente -->
            <div v-if="clienteSeleccionado"
              class="alert alert-success d-flex align-items-center justify-content-between py-2 px-3 mb-2 font-size-13">
              <div class="d-flex align-items-center overflow-hidden">
                <i class="mdi mdi-check-circle text-success font-size-20 me-2"></i>
                <div class="overflow-hidden">
                  <div class="fw-bold text-truncate">{{ obtenerNombreCompleto(clienteSeleccionado) }}</div>
                  <small class="text-muted">
                    ID: {{ clienteSeleccionado.id }} • No. Cliente: {{ clienteSeleccionado.numero || '-' }}
                  </small>
                </div>
              </div>
              <button type="button" class="btn btn-sm btn-outline-danger ms-2" @click="clienteSeleccionado = null"
                :disabled="enviando">
                <i class="mdi mdi-close"></i> Cambiar
              </button>
            </div>

            <!-- Buscador de clientes -->
            <div v-else>
              <div class="input-group mb-2">
                <span class="input-group-text bg-white border-end-0">
                  <i class="mdi mdi-magnify text-muted font-size-16"></i>
                </span>
                <input type="text" class="form-control border-start-0"
                  placeholder="Buscar cliente por nombre, ID o número..." v-model="criterioBusqueda"
                  @keyup.enter="buscarClientes(1)" :disabled="cargando || enviando" ref="inputBusquedaCliente" />
                <button class="btn btn-primary px-3" type="button" @click="buscarClientes(1)"
                  :disabled="cargando || enviando">
                  <span v-if="cargando" class="spinner-border spinner-border-sm me-1" role="status"></span>
                  <i v-else class="mdi mdi-magnify me-1"></i>
                  Buscar
                </button>
              </div>

              <!-- Tabla de resultados de búsqueda -->
              <div class="table-responsive rounded border bg-white" style="max-height: 220px;">
                <table class="table table-hover align-middle mb-0 font-size-12">
                  <thead class="table-light sticky-top">
                    <tr>
                      <th style="width: 60px;">ID</th>
                      <th>Cliente</th>
                      <th style="width: 110px;">No. Cliente</th>
                      <th style="width: 80px;" class="text-center">Estado</th>
                      <th style="width: 100px;" class="text-center">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="cargando">
                      <td colspan="5" class="text-center py-4 text-muted">
                        <span class="spinner-border spinner-border-sm text-primary me-2"></span>
                        Buscando clientes...
                      </td>
                    </tr>
                    <tr v-else-if="clientes.length === 0 && busquedaRealizada">
                      <td colspan="5" class="text-center py-4 text-muted">
                        No se encontraron clientes para "{{ criterioBusqueda }}".
                      </td>
                    </tr>
                    <tr v-else-if="clientes.length === 0">
                      <td colspan="5" class="text-center py-4 text-muted">
                        Ingresa un nombre o número y haz clic en Buscar.
                      </td>
                    </tr>
                    <tr v-for="c in clientes" :key="c.id"
                      :class="{ 'table-success': clienteSeleccionado && clienteSeleccionado.id === c.id }">
                      <td class="fw-semibold">#{{ c.id }}</td>
                      <td>
                        <span class="fw-semibold d-block text-dark">{{ obtenerNombreCompleto(c) }}</span>
                        <small v-if="c.telefonos && c.telefonos.length" class="text-muted">
                          Tels: {{ c.telefonos.map(t => t.numero).filter(Boolean).join(', ') }}
                        </small>
                      </td>
                      <td class="text-muted">{{ c.numero || '-' }}</td>
                      <td class="text-center">
                        <span class="badge"
                          :class="c.activo ? 'bg-soft-success text-success' : 'bg-soft-danger text-danger'">
                          {{ c.activo ? 'Activo' : 'Inactivo' }}
                        </span>
                      </td>
                      <td class="text-center">
                        <button type="button" class="btn btn-xs btn-outline-success" @click="seleccionarCliente(c)">
                          <i class="mdi mdi-check me-1"></i> Seleccionar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Step 3: Opción de enviar plantilla de inicio de conversación -->
          <div class="form-check form-switch mt-3">
            <input class="form-check-input" type="checkbox" id="switchEnviarPlantilla" v-model="enviarPlantilla"
              :disabled="enviando" />
            <label class="form-check-label font-size-13 fw-semibold text-dark cursor-pointer"
              for="switchEnviarPlantilla">
              Enviar plantilla oficial de inicio de conversación de inmediato
            </label>
            <div class="text-muted font-size-11">
              Si está activado, Meta WhatsApp enviará la plantilla configurada para aperturar la ventana de 24 horas con el contacto.
            </div>
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer bg-light py-2">
          <button type="button" class="btn btn-secondary font-size-13" @click="cerrar" :disabled="enviando">
            <i class="mdi mdi-close me-1"></i>
            Cancelar
          </button>
          <button type="button" class="btn btn-success font-size-13 d-inline-flex align-items-center"
            @click="inicializar" :disabled="enviando || !numeroTelefonoValido">
            <span v-if="enviando" class="spinner-border spinner-border-sm me-2" role="status"></span>
            <i v-else class="mdi mdi-send-check-outline me-1"></i>
            <span>{{ enviando ? 'Iniciando conversación...' : 'Iniciar conversación' }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "bootstrap/js/dist/modal";
import Swal from "sweetalert2";
import ClienteSrv from "@/services/ClienteSrv.js";
import SistemaSrv from "@/services/SistemaSrv.js";
import WhatsappSrv from "@/services/WhatsappSrv.js";

export default {
  name: "MdlInicializarConversacionWhatsapp",
  emits: ["conversacion-iniciada"],
  data() {
    return {
      visible: false,
      modalInstancia: null,
      prefijo: "52",
      numeroTelefono: "",
      tipoAsignacion: "varios", // 'varios' | 'cliente'
      clienteSeleccionado: null,
      enviarPlantilla: true,
      enviando: false,

      // Buscador de clientes
      criterioBusqueda: "",
      cargando: false,
      clientes: [],
      busquedaRealizada: false,
      paginaActual: 1,
      totalPaginas: 1
    };
  },
  computed: {
    numeroTelefonoValido() {
      const limpio = String(this.numeroTelefono || "").replace(/\D/g, "");
      return limpio.length >= 8;
    }
  },
  mounted() {
    if (this.$refs.mdlInicializarConversacion) {
      try {
        this.modalInstancia = new Modal(this.$refs.mdlInicializarConversacion);
      } catch (e) { }
    }
    this.cargarPrefijoPredeterminado();
  },
  methods: {
    abrir() {
      this.mostrar();
    },

    mostrar() {
      this.numeroTelefono = "";
      this.tipoAsignacion = "varios";
      this.clienteSeleccionado = null;
      this.enviarPlantilla = true;
      this.enviando = false;
      this.criterioBusqueda = "";
      this.clientes = [];
      this.busquedaRealizada = false;
      this.visible = true;

      if (!this.modalInstancia && this.$refs.mdlInicializarConversacion) {
        try {
          this.modalInstancia = new Modal(this.$refs.mdlInicializarConversacion);
        } catch (e) { }
      }
      if (this.modalInstancia) {
        try {
          this.modalInstancia.show();
        } catch (e) { }
      }

      this.$nextTick(() => {
        if (this.$refs.inputNumero) {
          this.$refs.inputNumero.focus();
        }
      });
    },

    cerrar() {
      this.visible = false;
      if (this.modalInstancia) {
        try {
          this.modalInstancia.hide();
        } catch (e) { }
      }
    },

    cargarPrefijoPredeterminado() {
      SistemaSrv.ajustes(["prefijo_telefonico"])
        .then((response) => {
          const valor = response?.data?.prefijo_telefonico;
          if (valor) {
            this.prefijo = String(valor).replace(/\D/g, "");
          }
        })
        .catch(() => { });
    },

    enfocarBusqueda() {
      if (this.tipoAsignacion === "cliente" && this.$refs.inputBusquedaCliente) {
        this.$refs.inputBusquedaCliente.focus();
      }
    },

    alCambiarTipoAsignacion() {
      if (this.tipoAsignacion === "cliente" && this.clientes.length === 0) {
        this.$nextTick(() => {
          if (this.$refs.inputBusquedaCliente) {
            this.$refs.inputBusquedaCliente.focus();
          }
          this.buscarClientes(1);
        });
      }
    },

    obtenerNombreCompleto(c) {
      if (!c) return "";
      const partes = [c.nombre, c.apellido_paterno, c.apellido_materno].filter(Boolean);
      return partes.join(" ");
    },

    seleccionarCliente(cliente) {
      this.clienteSeleccionado = cliente;
    },

    buscarClientes(pagina = 1) {
      this.cargando = true;
      this.paginaActual = pagina;
      this.busquedaRealizada = true;

      const params = {
        dato: this.criterioBusqueda,
      };

      ClienteSrv.clientesJSON(params)
        .then((response) => {
          let listado = [];
          if (response.data) {
            listado = response.data.clientes;
          }

          this.clientes = listado;
          if (response && (response.last_page || response.ultima_pagina)) {
            this.totalPaginas = Number(response.last_page || response.ultima_pagina) || 1;
          }
        })
        .catch((error) => {
          console.error("Error al buscar clientes:", error);
          this.clientes = [];
        })
        .finally(() => {
          this.cargando = false;
        });
    },

    inicializar() {
      if (!this.numeroTelefonoValido) {
        if (typeof iu !== "undefined" && iu.msg) {
          iu.msg.error("Por favor ingresa un número de teléfono válido.");
        }
        return;
      }

      if (this.tipoAsignacion === "cliente" && !this.clienteSeleccionado) {
        if (typeof iu !== "undefined" && iu.msg) {
          iu.msg.error("Por favor selecciona un cliente de la lista o elige 'Cliente Varios'.");
        }
        return;
      }

      const numLimpio = String(this.numeroTelefono).replace(/\D/g, "");
      const prefLimpio = String(this.prefijo || "52").replace(/\D/g, "");

      const payload = {
        numero: numLimpio,
        prefijo: prefLimpio,
        enviar_plantilla: this.enviarPlantilla,
        id_cliente: this.tipoAsignacion === "cliente" && this.clienteSeleccionado ? this.clienteSeleccionado.id : null
      };

      this.enviando = true;

      WhatsappSrv.inicializarNuevoContacto(payload)
        .then((response) => {
          const data = response?.data || {};
          const telCliente = data.telefono_cliente || null;

          if (typeof iu !== "undefined" && iu.msg) {
            iu.msg.success(data.message || "Conversación iniciada con éxito");
          }

          this.cerrar();
          this.$emit("conversacion-iniciada", {
            telefono_cliente: telCliente,
            cliente: telCliente?.cliente || this.clienteSeleccionado || null
          });
        })
        .catch((error) => {
          console.error("Error al inicializar conversación:", error);
          const errData = error?.response?.data || {};
          const msg = errData.message || (errData.error && errData.error.message) || "Error al iniciar la conversación";
          if (typeof iu !== "undefined" && iu.msg) {
            iu.msg.error(msg);
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: msg
            });
          }
        })
        .finally(() => {
          this.enviando = false;
        });
    }
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.btn-xs {
  padding: 0.18rem 0.45rem;
  font-size: 0.75rem;
}
</style>

